var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHintZ102102 = function SvgHintZ102102(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 102,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hint_z_102_102_svg__a)",
    d: "M90 12H12v78h78z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3177FF",
    d: "M6 0h90v6H6zM6 96h90v6H6zM6 6v90H0V6zM102 6v90h-6V6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.477 78v-2.422H30V58.982h2.95v-4.163h3.003v-4.057h2.95v-4.055H41.8v-4.743h-9.324v-2.267H30V26.213h2.477V24h36.982v2.422h2.425v16.542h-2.952v4.163h-3v4.108h-2.954v4.111h-2.895v4.69h9.376v2.213h2.425v13.484H69.46V78z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hint_z_102_102_svg__b)",
    d: "M33.317 72.257V62.3h2.953v-4.163h3v-4.054h2.953v-4.058h2.896v-4.003h2.898v-3.953h2.791v-3.423H35.794V36.38h-2.477v-6.848h2.477v-2.213H66.14v2.422h2.423v9.906h-2.95v4.163H62.61v4.108h-2.95v4.108h-2.899v3.953h-2.895v3.9h-2.794v3.476H66.14v2.213h2.423v6.848H66.14v2.267H35.794v-2.425z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hint_z_102_102_svg__a",
    x1: 11.64,
    x2: 90.358,
    y1: 11.565,
    y2: 90.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3E2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hint_z_102_102_svg__b",
    x1: 32.32,
    x2: 69.561,
    y1: 26.253,
    y2: 75.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7474E6"
  })))));
};
export default SvgHintZ102102;